import { Subject } from 'core/models/subject.model';

export const MOCK_SUBJECTS: Subject[] = [
  {
    id: 'subject-001',
    name: 'Matemática',
    institutionId: 'inst-001',
    knowledgeArea: 'mathematics',
    status: 'active',
    createdAt: '2025-12-01T10:00:00.000Z',
    updatedAt: '2026-01-10T10:00:00.000Z',
  },
  {
    id: 'subject-002',
    name: 'Língua Portuguesa',
    institutionId: 'inst-001',
    knowledgeArea: 'languages',
    status: 'active',
    createdAt: '2025-12-01T10:00:00.000Z',
    updatedAt: '2026-01-10T10:00:00.000Z',
  },
  {
    id: 'subject-003',
    name: 'Ciências',
    institutionId: 'inst-001',
    knowledgeArea: 'natural_sciences',
    status: 'active',
    createdAt: '2025-12-01T10:00:00.000Z',
    updatedAt: '2026-01-10T10:00:00.000Z',
  },
  {
    id: 'subject-004',
    name: 'História',
    institutionId: 'inst-001',
    knowledgeArea: 'human_sciences',
    status: 'active',
    createdAt: '2025-12-01T10:00:00.000Z',
    updatedAt: '2026-01-10T10:00:00.000Z',
  },
  {
    id: 'subject-005',
    name: 'Física',
    institutionId: 'inst-002',
    knowledgeArea: 'natural_sciences',
    status: 'active',
    createdAt: '2025-12-01T10:00:00.000Z',
    updatedAt: '2026-01-10T10:00:00.000Z',
  },
  {
    id: 'subject-006',
    name: 'Química',
    institutionId: 'inst-002',
    knowledgeArea: 'natural_sciences',
    status: 'active',
    createdAt: '2025-12-01T10:00:00.000Z',
    updatedAt: '2026-01-10T10:00:00.000Z',
  },
];
